module.exports = new __parcel__URL__("steam-power-plant.18dc4d60.png").toString();